import React, { Component } from 'react';
import { usePackages } from '../context/ProjectContext';
import '../Styles/packages.css';

// Wrapper to use hooks in class component
function PackagesWrapper() {
  const { packages, loading, error, deletePackage } = usePackages();
  return <PackagesComponent 
    packages={packages} 
    loading={loading} 
    error={error}
    deletePackage={deletePackage} 
  />;
}

class PackagesComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeAccordion: null,
      activeTab: {} // Track active tab for each package (itinerary/inclusions/exclusions)
    };
  }

  toggleAccordion = (index) => {
    this.setState(prevState => ({
      activeAccordion: prevState.activeAccordion === index ? null : index,
      // Reset active tab when opening a new package
      activeTab: prevState.activeAccordion === index ? prevState.activeTab : { ...prevState.activeTab, [index]: 'itinerary' }
    }));
  };

  setActiveTab = (packageIndex, tab) => {
    this.setState(prevState => ({
      activeTab: {
        ...prevState.activeTab,
        [packageIndex]: tab
      }
    }));
  };

  handleDeletePackage = async (id, event) => {
    event.stopPropagation();
    if (window.confirm('Are you sure you want to delete this package? This action cannot be undone.')) {
      const result = await this.props.deletePackage(id);
      if (result.success) {
        alert('Package deleted successfully!');
      } else {
        alert(`Failed to delete package: ${result.error}`);
      }
    }
  };

  render() {
    const { packages, loading, error } = this.props;
    const { activeAccordion, activeTab } = this.state;

    if (loading) {
      return (
        <div className="loading-container">
          <div className="loader">
            <div className="spinner"></div>
            <p>Loading packages...</p>
          </div>
        </div>
      );
    }

    if (error) {
      return (
        <div className="error-container">
          <h2>Error Loading Packages</h2>
          <p>{error}</p>
          <button onClick={() => window.location.reload()}>Retry</button>
        </div>
      );
    }

    return (
      <div className="packages-page">
        {/* Hero Section */}
        <div className="packages-hero">
          <div className="packages-hero-overlay"></div>
          <div className="packages-hero-content">
            <h1 className="packages-hero-title">Our Packages</h1>
            <p className="packages-hero-subtitle">
              Discover unforgettable journeys tailored just for you
            </p>
            <div className="packages-stats">
              <div className="stat">
                <span className="stat-number">{packages.length}+</span>
                <span className="stat-text">Available Packages</span>
              </div>
              <div className="stat">
                <span className="stat-number">1000+</span>
                <span className="stat-text">Happy Travelers</span>
              </div>
              <div className="stat">
                <span className="stat-number">24/7</span>
                <span className="stat-text">Support Available</span>
              </div>
            </div>
          </div>
        </div>

        {/* Add Package Button */}
        {/* <div className="add-package-float">
          <button 
            className="add-package-btn"
            onClick={() => window.location.href = '/add-package'}
          >
            + Add New Package
          </button>
        </div> */}

        {/* Packages List */}
        <div className="packages-list-container">
          {packages.length === 0 ? (
            <div className="no-packages">
              <p>No packages available. Click "Add New Package" to create one.</p>
            </div>
          ) : (
            packages.map((pkg, index) => (
              <div key={pkg.id} className="package-item">
                <div 
                  className={`package-header ${activeAccordion === index ? 'active' : ''}`}
                  onClick={() => this.toggleAccordion(index)}
                >
                  <div className="package-header-content">
                    <div className="package-info">
                      <h3 className="package-title">{pkg.title}</h3>
                      <div className="package-meta">
                        <span className="package-duration">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                            <path d="M12 8V12L15 15M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" strokeWidth="2"/>
                          </svg>
                          {pkg.duration}
                        </span>
                        <span className="package-price">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M6 3H18M6 8H18M6 13H15C17.2091 13 19 11.2091 19 9C19 6.79086 17.2091 5 15 5H6L12 11M12 11L8 16M12 11L16 16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
                          {pkg.price}
                        </span>
                        <span className="package-rating">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                            <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="currentColor"/>
                          </svg>
                          {pkg.rating}
                        </span>
                      </div>
                    </div>
                    <div className="package-actions">
                      {/* <button 
                        className="delete-package-btn"
                        onClick={(e) => this.handleDeletePackage(pkg.id, e)}
                        title="Delete Package"
                      >
                        🗑️
                      </button> */}
                      <div className="package-icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                          <path d="M19 9L12 16L5 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className={`package-content ${activeAccordion === index ? 'active' : ''}`}>
                  {/* Tab Navigation */}
                  <div className="package-tabs">
                    <button 
                      className={`package-tab-btn ${activeTab[index] === 'itinerary' || !activeTab[index] ? 'active' : ''}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        this.setActiveTab(index, 'itinerary');
                      }}
                    >
                      📅 Itinerary
                    </button>
                    <button 
                      className={`package-tab-btn ${activeTab[index] === 'inclusions' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        this.setActiveTab(index, 'inclusions');
                      }}
                    >
                      ✅ Inclusions
                    </button>
                    <button 
                      className={`package-tab-btn ${activeTab[index] === 'exclusions' ? 'active' : ''}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        this.setActiveTab(index, 'exclusions');
                      }}
                    >
                      ❌ Exclusions
                    </button>
                  </div>

                  {/* Tab Content */}
                  <div className="tab-content">
                    {/* Itinerary Tab */}
                    {(activeTab[index] === 'itinerary' || !activeTab[index]) && (
                      <div className="itinerary-tab">
                        <div className="itinerary">
                          {pkg.days && pkg.days.map((day, dayIndex) => (
                            <div key={dayIndex} className="itinerary-day">
                              <div className="day-number">
                                <span>Day {day.day}</span>
                              </div>
                              <div className="day-content">
                                <h4 className="day-title">{day.title}</h4>
                                <p className="day-description">{day.description}</p>
                                {day.highlights && day.highlights.length > 0 && (
                                  <div className="day-highlights">
                                    {day.highlights.map((highlight, idx) => (
                                      <span key={idx} className="highlight-badge">
                                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                                          <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                        </svg>
                                        {highlight}
                                      </span>
                                    ))}
                                  </div>
                                )}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {/* Inclusions Tab */}
                    {activeTab[index] === 'inclusions' && (
                      <div className="inclusions-tab">
                        <h3>What's Included</h3>
                        <ul className="inclusions-list">
                          {pkg.inclusions && pkg.inclusions.length > 0 ? (
                            pkg.inclusions.map((inclusion, idx) => (
                              <li key={idx}>
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                  <path d="M20 6L9 17L4 12" stroke="#28a745" strokeWidth="2" strokeLinecap="round"/>
                                </svg>
                                {inclusion}
                              </li>
                            ))
                          ) : (
                            <li>No inclusions specified</li>
                          )}
                        </ul>
                      </div>
                    )}

                    {/* Exclusions Tab */}
                    {activeTab[index] === 'exclusions' && (
                      <div className="exclusions-tab">
                        <h3>What's Excluded</h3>
                        <ul className="exclusions-list">
                          {pkg.exclusions && pkg.exclusions.length > 0 ? (
                            pkg.exclusions.map((exclusion, idx) => (
                              <li key={idx}>
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                  <path d="M18 6L6 18M6 6L18 18" stroke="#dc3545" strokeWidth="2" strokeLinecap="round"/>
                                </svg>
                                {exclusion}
                              </li>
                            ))
                          ) : (
                            <li>No exclusions specified</li>
                          )}
                        </ul>
                      </div>
                    )}
                  </div>

                  {/* Remark Note Section */}
                  {pkg.remark && (
                    <div className="package-remark">
                      <div className="remark-icon">📝</div>
                      <div className="remark-content">
                        <strong>Important Note:</strong>
                        <p>{pkg.remark}</p>
                      </div>
                    </div>
                  )}
                  
                  <div className="package-footer">
                    <button className="book-now-btn">
                      <span>Book This Package</span>
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                        <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2"/>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    );
  }
}

export default PackagesWrapper;